import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import cls from '../styles.module.scss'

export const TextContentEs = () => {
    return (
        <HighlightedText
            text="325% de bono + 400 GIROS GRATIS"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakBeforeWords={['GIROS']}
            className={cls.text}
        />
    )
}
